export default function ConfidenceMeter({ value = 0, size = "md" }) {
  const filled = Math.max(0, Math.min(10, Math.round(value * 10)));
  const blocks = Array.from({ length: 10 }, (_, i) => i < filled);

  const heightMap = { sm: "h-1.5", md: "h-2.5", lg: "h-3.5" };
  const height = heightMap[size] || heightMap.md;

  const colorForBlock = (i) => {
    if (i < filled) {
      if (filled >= 8) return "bg-emerald-600";
      if (filled >= 5) return "bg-amber-500";
      return "bg-red-500";
    }
    return "bg-zinc-200";
  };

  return (
    <div className="flex items-center gap-2">
      <div className="grid grid-cols-10 gap-0.5 flex-1" data-testid="confidence-meter">
        {blocks.map((_, i) => (
          <div key={i} className={`${height} ${colorForBlock(i)} transition-colors`} />
        ))}
      </div>
      <span className="font-mono-plex text-[11px] font-semibold text-zinc-900 min-w-[36px] text-right">
        {Math.round(value * 100)}%
      </span>
    </div>
  );
}
